module.exports = __webpack_public_path__ + "static/media/product-partners.6e149cab.svg";